import React from "react";
import { useTranslation } from "react-i18next";

const PackageAlert = ({ planName, expiryDate }) => {
  const { i18n } = useTranslation();

  return (
    <p className="alert bg-[#8EDDD6] text-black text-[15px] mb-3 rounded justify-start gap-2 py-3">
      {i18n.language === "ar"
        ? `أنت تستخدم حاليا ${planName} الحزمة التي ستنتهي صلاحيتها في ${expiryDate} (dd/mm/yyyy)`
        : `You are currently using ${planName} Package which will Expire on ${expiryDate} (dd/mm/yyyy)`}
    </p>
  );
};

export default PackageAlert;
